exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DhkJau9SeKcA7TOLklouR{width:32px;height:32px;line-height:32px}html[dir] .DhkJau9SeKcA7TOLklouR{border-radius:50%;text-align:center}._1ZeJdYuEm2X1X4XJXlRe2P{color:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"roomIconContainer": "DhkJau9SeKcA7TOLklouR",
	"roomIcon": "_1ZeJdYuEm2X1X4XJXlRe2P"
};